import styled from 'styled-components';

export const DropDownWrapper = styled.div`
	background-color: #fff; /* Background color */
	border: 1px solid #ccc; /* Border */
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); /* Shadow for depth */
	border-radius: 4px; /* Rounded corners */
	z-index: 1000; /* Ensure it appears above other elements */
	display: flex;
	align-items: center;
	height: 1rem;
`;

export const DropDownList = styled.ul`
	position: absolute;
	list-style: none; /* Remove default list styles */
	padding: 0; /* Remove padding */
	margin: 0; /* Remove margin */
	z-index: 1000;
	border-radius: 6px;
	background-color: white;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

	li {
		padding: 10px 15px; /* Padding for spacing */
		cursor: pointer; /* Pointer cursor on hover */
		transition: background-color 0.3s; /* Smooth background color transition */

		&:hover {
			background-color: #f0f0f0; /* Change background color on hover */
		}

		&:active {
			background-color: #e0e0e0; /* Darker background when clicked */
		}
	}
`;
